import React from "react";
import PropTypes from "prop-types";

export default function HelpIconSVG(props) {
  const {
    styles: {
      height,
      width,
      fill
    }
  } = props;
  return (
    <svg
      id={props.id || ''}
      className={props.className || ''}
      height={height || "32px"}
      width={width || "32px"}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
    >
      <g id="Personal-Details" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Returning,-Edit-FanProtect-(2-error)" transform="translate(-280.000000, -313.000000)" fill={fill}>
          <g id="Group-11" transform="translate(16.000000, 297.000000)">
            <g id="Icon/Alert/Help" transform="translate(264.000000, 16.000000)">
              <path
                d="M8,0.5 C3.86734694,0.5 0.5,3.86734694 0.5,8 C0.5,12.1326531 3.86734694,15.5 8,15.5 C12.1326531,15.5 15.5,12.1326531 15.5,8 C15.5,3.86734694 12.1326531,0.5 8,0.5 L8,0.5 Z M7.93877551,11.9183673 C7.60204082,11.9183673 7.32653061,11.6428571 7.32653061,11.3061224 C7.32653061,10.9693878 7.60204082,10.6938776 7.93877551,10.6938776 C8.2755102,10.6938776 8.55102041,10.9693878 8.55102041,11.3061224 C8.55102041,11.6428571 8.2755102,11.9183673 7.93877551,11.9183673 L7.93877551,11.9183673 Z M9.31632653,8.79591837 C8.85714286,9.10204082 8.55102041,9.56122449 8.55102041,10.0816327 L7.32653061,10.0816327 C7.32653061,9.16326531 7.81632653,8.2755102 8.64285714,7.75510204 C9.04081633,7.51020408 9.28571429,7.08163265 9.25510204,6.59183673 C9.2244898,5.8877551 8.67346939,5.33673469 7.96938776,5.30612245 C7.60204082,5.30612245 7.26530612,5.42857143 7.02040816,5.67346939 C6.7755102,5.91836735 6.62244898,6.25510204 6.62244898,6.62244898 L5.39795918,6.62244898 C5.39795918,5.91836735 5.67346939,5.2755102 6.16326531,4.78571429 C6.65306122,4.29591837 7.29591837,4.05102041 8,4.05102041 C9.31632653,4.08163265 10.4489796,5.21428571 10.4795918,6.53061224 C10.5102041,7.44897959 10.0816327,8.30612245 9.31632653,8.79591837 L9.31632653,8.79591837 Z"
                id="help-30px">
              </path>
            </g>
          </g>
        </g>
      </g>
    </svg>

  );
}

HelpIconSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

HelpIconSVG.defaultProps = {
  styles: {
    fill: "#12BAC2",
    height: "32px",
    width: "32px"
  }
};
